import React, { Fragment, useState, useEffect } from 'react'
import Header from '../Header';
import Sidebar from '../../layout/Sidebar'
import { connect } from 'react-redux';
import { updateCategory, getCurrentCategory } from '../../../actions/category';
import { logout } from '../../../actions/auth';

import {  Link, useParams } from 'react-router-dom';



import PropTypes from 'prop-types';

const EditCategory = ({ getCurrentCategory, updateCategory, category: { category, loading } }) => {


    const { id } = useParams();
    const [formData, setFormData] = useState({

        categoryName: '',
        description: '',
    });
    useEffect(() => {
        getCurrentCategory(id);
    }, [getCurrentCategory, id]);

    useEffect(() => {

        setFormData({
            categoryName: loading || !category.categoryName ? '' : category.categoryName,
            description: loading || !category.description ? '' : category.description
        });

    }, [category]);

    const { categoryName, description } = formData;
    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
    const onSubmit = e => {
        console.log(formData);
        e.preventDefault();
        updateCategory(id, formData);

    };


    return (
        <Fragment>
            <div className='wrapper'>
                <Sidebar />
                <div className='servicePage'>
                    <Header heading="Edit Category" />
                    <div className='createForm'>
                        <form className="form mt-5" onSubmit={e => onSubmit(e)}>
                            <div className="card">
                                <h5 className="card-header">Basic Info</h5>
                                <div className="card-body p-5">
                                    <input type="hidden" className='form-control form-control-lg ' name="id" id='id' value={id} />

                                    <div className='mb-5'>
                                        <label htmlFor='business_name' className="form-label">Service category name</label>
                                        <input type="text" className='form-control form-control-lg' name="categoryName" id='categoryName' value={categoryName} onChange={e => onChange(e)
                                        } required />
                                    </div>
                                    <div className="mb-5">
                                        <label htmlFor="businessEmail" className="form-label">Service category description</label>
                                        <textarea className='form-control form-control-lg' name="description" id='description' value={description} onChange={e => onChange(e)
                                        } required />
                                    </div>
                                </div>
                            </div>
                            <div className='text-center pt-4 d-flex justify-content-end'>
                                <Link to='/services' className="btn btn-custom me-4"  >Cancel</Link>
                                <input type="submit" className="btn btn-custom" value="Update" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>
    );

}

EditCategory.propTypes = {
    logout: PropTypes.func.isRequired,
    updateCategory: PropTypes.func.isRequired,
    getCurrentCategory: PropTypes.func.isRequired,
}
const mapStateToProps = state => ({
    category: state.category
});

export default connect(mapStateToProps, { updateCategory, getCurrentCategory, logout })(EditCategory);
